import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import { StudentGrade, Timezones } from "../../common/const";

const StudentDetails = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#FFFCCF"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Student & Parent Information</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Student Details</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={4}>
                        <CommonFormField
                            label="First Name"
                            type="email"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            placeholder="Enter first name"
                            error={errors.firstName}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Last Name"
                            type="email"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            placeholder="Enter last name"
                            error={errors.lastName}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="School Email"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email id"
                            error={errors.email}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="School Name"
                            type="email"
                            name="schoolName"
                            value={formData.schoolName}
                            onChange={handleInputChange}
                            placeholder="Enter school name"
                            error={errors.schoolName}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonSelect
                            label="Grade"
                            name="grade"
                            value={formData.grade}
                            onChange={handleInputChange}
                            placeholder="Select Grade"
                            options={StudentGrade}
                            error={errors.grade}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Parent Name"
                            type="email"
                            name="parentName"
                            value={formData.parentName}
                            onChange={handleInputChange}
                            placeholder="Enter parent name"
                            error={errors.parentName}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Parent Email"
                            type="email"
                            name="parentEmail"
                            value={formData.parentEmail}
                            onChange={handleInputChange}
                            placeholder="Enter parent email"
                            error={errors.parentEmail}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonSelect
                            label="Time Zone"
                            name="timezone"
                            value={formData.timezone}
                            onChange={handleInputChange}
                            placeholder="Select Timezone"
                            options={Timezones}
                            error={errors.timezone}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Major"
                            type="email"
                            name="major"
                            value={formData.major}
                            onChange={handleInputChange}
                            placeholder="Enter major"
                            error={errors.major}
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default StudentDetails;